import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getProfile } from '../lib/advisorProfile';
import { useTenant } from '../context/TenantContext';

interface OnboardingState {
  needsOnboarding: boolean;
  loading: boolean;
}

export const ONBOARDING_SKIP_KEY = 'ww-skip-onboarding';

export function useOnboarding(): OnboardingState {
  const { locationId } = useTenant();
  const location = useLocation();
  const [state, setState] = useState<OnboardingState>({
    needsOnboarding: false,
    loading: true,
  });

  useEffect(() => {
    if (!locationId) {
      setState({ needsOnboarding: false, loading: false });
      return;
    }

    try {
      if (sessionStorage.getItem(ONBOARDING_SKIP_KEY) === 'true') {
        setState({ needsOnboarding: false, loading: false });
        return;
      }
    } catch {
      // sessionStorage unavailable — fall through to fetch
    }

    let cancelled = false;
    setState((s) => ({ ...s, loading: true }));

    async function check() {
      try {
        const profile = await getProfile(locationId);
        if (!cancelled) {
          const needs = !profile || !profile.advisor_name?.trim();
          setState({ needsOnboarding: needs, loading: false });
        }
      } catch {
        if (!cancelled) {
          setState({ needsOnboarding: false, loading: false });
        }
      }
    }

    check();
    return () => { cancelled = true; };
  }, [locationId, location.pathname]);

  return state;
}
